export default "__VITE_ASSET__BjDRnfyE__"